import styled from "styled-components";
import { typography } from "src/theme";
import { colors } from "src/theme/colors";
import device from "src/constants/media";

export const ContentWrapper = styled.div`
  display: block;
  background-color: ${colors.greyVeryLight};
  width: 100%;
  padding: 16px 16px;
  font-family: ${typography.fontFamily};
  border-radius: 10px;
  margin-bottom: 50px;

  @media ${device.tablet} {
    margin-top: 35px;
    max-width: 399px;
  }
`;
export const RatingInfoWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.greyLight};
  margin-bottom: 16px;
`;
export const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 16px;
  color: ${colors.grey};
`;

export const Rate = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 11px;
`;

export const Score = styled.div`
  font-size: 36px;
  color: ${colors.grey};
  margin-right: 8px;
`;

export const AmountOfReviews = styled.div`
  color: ${colors.grey};
`;

export const StarsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const Star = styled.div`
  margin-right: 5px;
`;
